import React from 'react';
import { Users, BookCopy, Star, Globe } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-accent text-brand-dark py-2 px-3 shadow-[0_0_20px_rgba(0,255,136,0.3)] relative z-20" data-id="element-175">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-[10px] md:text-xs font-black text-center uppercase tracking-wide" data-id="element-176">
        <div className="flex items-center" data-id="element-177">
          <Users className="w-3 h-3 md:w-4 md:h-4 mr-1" data-id="element-178" />
          <span data-id="element-179">+2.500 docentes confían</span>
        </div>
        <span className="hidden md:inline opacity-50" data-id="element-180">|</span>
        <div className="flex items-center" data-id="element-181">
          <BookCopy className="w-3 h-3 md:w-4 md:h-4 mr-1" data-id="element-182" />
          <span data-id="element-183">6 tomos premium</span>
        </div>
        <span className="hidden md:inline opacity-50" data-id="element-184">|</span>
        <div className="flex items-center" data-id="element-185">
          <Star className="w-3 h-3 md:w-4 md:h-4 mr-1 fill-current" data-id="element-186" />
          <span data-id="element-187">4,9/5 calificación</span>
        </div>
        <span className="hidden md:inline opacity-50" data-id="element-188">|</span>
        <div className="flex items-center" data-id="element-189">
          <Globe className="w-3 h-3 md:w-4 md:h-4 mr-1" data-id="element-190" />
          <span data-id="element-191">Todo el mundo hispanohablante</span>
        </div>
      </div>
    </div>;
}